"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _userResume = require("@/api/retailer/userResume");
var _editFrom = _interopRequireDefault(require("./editFrom.vue"));
var _importForm = _interopRequireDefault(require("./importForm.vue"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RetailerUserResumeIndex',
  components: {
    editFrom: _editFrom.default,
    importForm: _importForm.default
  },
  data: function data() {
    return {
      tableData: {
        data: [],
        total: 0
      },
      listLoading: true,
      queryParams: {
        orderStatus: undefined,
        batchNo: undefined,
        orderNo: undefined,
        recipientName: undefined,
        recipientPhone: undefined,
        dateLimit: '',
        page: 1,
        limit: 20
      },
      timeVal: [],
      fromList: this.$constants.fromList,
      refreshLoading: false,
      card_select_show: false,
      checkAll: false,
      checkedCities: ['批次号', '商品规格编码', '商品规格名称', '商品名称', '订单状态', '订单号', '下单数量', '下单时间', '运单号', '快递公司', '收件人姓名', '收件人手机号', '收件人地址', '失败原因'],
      columnData: ['批次号', '商品规格编码', '商品规格名称', '商品名称', '订单状态', '订单号', '下单数量', '下单时间', '运单号', '快递公司', '收件人姓名', '收件人手机号', '收件人地址', '失败原因'],
      isIndeterminate: true,
      multipleSelection: [],
      orderLoading: false
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    seachList: function seachList() {
      this.queryParams.page = 1;
      this.getList();
    },
    // 列表
    getList: function getList() {
      var _this = this;
      this.listLoading = true;
      (0, _userResume.userResumeListApi)(this.queryParams).then(function (res) {
        _this.tableData.data = res.list || [];
        _this.tableData.total = res.total;
        _this.listLoading = false;
        _this.checkedCities = _this.$cache.local.has('order_stroge') ? _this.$cache.local.getJSON('order_stroge') : _this.checkedCities;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      this.queryParams.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.queryParams.limit = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 编辑
    handleEdit: function handleEdit(row) {
      this.$refs.editRef.open(row);
    },
    // 批量删除
    handleDelBatch: function handleDelBatch() {
      var _this2 = this;
      this.$modalSure('确定删除该履历吗？').then(function () {
        (0, _userResume.userResumeDelApi)({
          orderIds: _this2.multipleSelection.map(function (item) {
            return item.id;
          })
        }).then(function (res) {
          _this2.$message.success('删除成功');
          _this2.getList();
        });
      });
    },
    // 刷新订单状态
    handleRefresh: function handleRefresh() {
      var _this3 = this;
      this.refreshLoading = true;
      (0, _userResume.userResumeRefreshApi)().then(function (res) {
        _this3.$message.success('刷新成功');
        _this3.refreshLoading = false;
        _this3.getList();
      });
    },
    // 导出
    // exports() {
    //   const queryParams = {
    //     orderStatus: this.queryParams.orderStatus,
    //     batchNo: this.queryParams.batchNo,
    //     orderNo: this.queryParams.orderNo,
    //     recipientName: this.queryParams.recipientName,
    //     recipientPhone: this.queryParams.recipientPhone,
    //   };
    //   userResumeExportApi(queryParams).then((res) => {
    //     window.open(res.fileName);
    //   });
    // },
    // 导入
    handleImport: function handleImport() {
      this.$refs.importRef.open();
    },
    // 批量下单
    handleBulkOrder: function handleBulkOrder() {
      var _this4 = this;
      var queryParams = {
        orderStatus: this.queryParams.orderStatus,
        batchNo: this.queryParams.batchNo,
        orderNo: this.queryParams.orderNo,
        recipientName: this.queryParams.recipientName,
        recipientPhone: this.queryParams.recipientPhone
      };
      var params = this.multipleSelection.length > 0 ? {
        orderIds: this.multipleSelection.map(function (item) {
          return item.id;
        })
      } : queryParams;
      (0, _userResume.userResumeBulkOrderApi)(params).then(function (res) {
        var msg = res.successCount + res.failCount == 1 ? res.successCount == 1 ? '下单成功' : '下单失败' : res.successCount + '条下单成功,' + res.failCount + '条下单失败';
        _this4.$message.success(msg);
        _this4.getList();
      });
    },
    // 下单
    handleOrder: function handleOrder(row) {
      var _this5 = this;
      this.orderLoading = true;
      (0, _userResume.userResumeBulkOrderApi)({
        orderIds: [row.id]
      }).then(function (res) {
        var msg = res.successCount == 1 ? '下单成功' : '下单失败';
        _this5.$message.success(msg);
        _this5.orderLoading = false;
        _this5.getList();
      });
    },
    // 导出
    handleExport: function handleExport() {
      var queryParams = {
        orderStatus: this.queryParams.orderStatus,
        batchNo: this.queryParams.batchNo,
        orderNo: this.queryParams.orderNo,
        recipientName: this.queryParams.recipientName,
        recipientPhone: this.queryParams.recipientPhone
      };
      var params = this.multipleSelection.length > 0 ? {
        orderIds: this.multipleSelection.map(function (item) {
          return item.id;
        })
      } : queryParams;
      (0, _userResume.userResumeExportApi)(params).then(function (res) {
        window.open(res.fileName);
      });
    },
    renderHeader: function renderHeader(h) {
      var _this6 = this;
      return h("p", [h("span", {
        "style": "padding-right:5px;"
      }, ["\u64CD\u4F5C"]), h("i", {
        "class": "el-icon-setting",
        "on": {
          "click": function click() {
            return _this6.handleAddItem();
          }
        }
      })]);
    },
    handleAddItem: function handleAddItem() {
      if (this.card_select_show) {
        this.$set(this, 'card_select_show', false);
      } else if (!this.card_select_show) {
        this.$set(this, 'card_select_show', true);
      }
    },
    handleCheckAllChange: function handleCheckAllChange(val) {
      this.checkedCities = val ? this.columnData : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.columnData.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.columnData.length;
    },
    checkSave: function checkSave() {
      this.card_select_show = false;
      this.$modal.loading('正在保存到本地，请稍候...');
      this.$cache.local.setJSON('order_stroge', this.checkedCities);
      setTimeout(this.$modal.closeLoading(), 1000);
    },
    // 新增方法：选择快捷时间（昨天、今天等）
    selectChange: function selectChange(tab) {
      this.queryParams.dateLimit = tab;
      this.timeVal = [];
      this.queryParams.page = 1;
      this.getList();
    },
    // 新增方法：自定义日期选择
    onchangeTime: function onchangeTime(e) {
      this.timeVal = e;
      this.queryParams.dateLimit = e ? this.timeVal.join(',') : '';
      this.queryParams.page = 1;
      this.getList();
    }
  }
};